(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beirut-footer-navigation"] && !Shopify.designMode) return;
  try {
    const footerMedia = window.matchMedia('(max-width: 749px)');
  const syncFooterGroups = () => {
    document.querySelectorAll('[data-bs-footer-group]').forEach((group) => {
      group.open = !footerMedia.matches;
    });
  };
  syncFooterGroups();
  footerMedia.addEventListener('change', syncFooterGroups);
  } catch(e) { console.error(e); }
})();

})();
